import { AutoPatchStatusEnum } from '@/react/portainer/settings/types';

import { Badge, BadgeType } from '@@/Badge';

export function StatusBadge({ status }: { status: AutoPatchStatusEnum }) {
  let statusType: BadgeType;
  let statusText: string;
  switch (status) {
    case AutoPatchStatusEnum.Completed:
      statusType = 'success';
      statusText = 'Succeeded';
      break;
    case AutoPatchStatusEnum.Failed:
      statusType = 'danger';
      statusText = 'Failed';
      break;
    case AutoPatchStatusEnum.InProgress:
    default:
      statusType = 'accent';
      statusText = 'In progress';
      break;
  }

  return <Badge type={statusType}>{statusText}</Badge>;
}
